import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { Suspense } from 'react';
import { Lazy } from '@root/src/web/components/Lazy';
import { canShowSignInGate } from '@frontend/web/components/SignInGate/displayRule';
import { initPerf } from '@root/src/web/browser/initPerf';
const SignInGateMain = React.lazy(() => {
    const { start, end } = initPerf('SignInGateMain');
    start();
    return import(
    /* webpackChunkName: "SignInGateMain" */ '../gateDesigns/SignInGateMain').then((module) => {
        end();
        return { default: module.SignInGateMain };
    });
});
export const signInGateComponent = {
    gate: ({ ophanComponentId, dismissGate, guUrl, signInUrl, abTest, isComment, }) => (_jsx(Lazy, Object.assign({ margin: 300 }, { children: _jsx(Suspense, Object.assign({ fallback: _jsx(_Fragment, {}, void 0) }, { children: _jsx(SignInGateMain, { ophanComponentId: ophanComponentId, dismissGate: dismissGate, guUrl: guUrl, signInUrl: signInUrl, abTest: abTest, isComment: isComment }, void 0) }), void 0) }), void 0)),
    canShow: canShowSignInGate,
};
